import { useGetBriefs } from "@entities/brief/lib/hooks/useGetBriefs";
import { useCampaignStore } from "@entities/global-discovery/store/useCampaignStore";
import { SelectButton } from "@shared/ui/Select";
import { useMemo, useState } from "react";

interface CampaignSelectorProps {
  isError?: boolean;
}

export function CampaignSelector({ isError }: CampaignSelectorProps) {
  const { campaign, setCampaign, campaignId } = useCampaignStore();

  const [searchValue, setSearchValue] = useState("");

  const { briefs, isFetching } = useGetBriefs({
    pageNo: 1,
    limit: 10,
    searchQuery: searchValue,
  });

  const options = useMemo(() => {
    if (campaign) {
      return [
        { label: campaign?.name, value: campaign?._id },
        ...briefs
          ?.filter((brief) => brief._id !== campaign?._id)
          .map((brief) => ({
            label: brief.name,
            value: brief._id,
          })),
      ];
    }
    return briefs?.map((brief) => ({
      label: brief.name,
      value: brief._id,
    }));
  }, [briefs, campaign]);

  return (
    <SelectButton
      size="large"
      isError={isError}
      value={campaign?._id}
      searchValue={searchValue}
      onSearchChange={setSearchValue}
      searchable={true}
      placeholder="Select a campaign"
      loading={isFetching}
      options={options}
      popOverPosition="bottomLeft"
      onChange={(campaignId: string) => {
        setCampaign(
          briefs?.find((brief) => brief._id === campaignId)!,
          campaignId
        );
      }}
    />
  );
}
